var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Colors } from '../ThemeProvider/type';
import { useProgress } from './useProgress';
/**
 * # Progress
 *
 * 진행상황을 쉽게 컨트롤 할 때 사용하세요.
 *
 * @param {ProgressProps} {@link ProgressProps}
 *
 * @example ```tsx
 * const [value, setValue] = useState(0)
 *
  <Progress
    value={value}
    colors={{
      0: Colors.PRIMARY.FOREGROUND,
      25: Colors.PRIMARY.ACCENT_5,
      50: Colors.WARNING.DEFAULT,
      75: Colors.HIGHLIGHT.PINK,
      100: Colors.SUCCESS.DEFAULT
    }}
  />
  <Button
    onClick={() => {
      if (value < 100) setValue(value + 10)
    }}
    size='medium'
  >
    Increase
  </Button>

  <Button
    onClick={() => {
      if (value > 0) setValue(value - 10)
    }}
    color='secondary'
  >
    Decrease
  </Button>
 * ```
 */
export var Progress = function (props) {
    var otherProps = __rest(useProgress(props), []);
    return <Bar {...otherProps}/>;
};
var ProgressTypeMapper = {
    primary: {
        background: Colors.PRIMARY.FOREGROUND
    },
    secondary: {
        background: Colors.PRIMARY.ACCENT_5
    },
    success: {
        background: Colors.SUCCESS.DEFAULT
    },
    error: {
        background: Colors.ERROR.DEFAULT
    },
    warning: {
        background: Colors.WARNING.DEFAULT
    }
};
var Bar = styled.progress(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  appearance: none;\n  border: none;\n  width: 100%;\n  height: 10px;\n  display: block;\n  vertical-align: unset;\n\n  ", "\n\n  ", "\n"], ["\n  appearance: none;\n  border: none;\n  width: 100%;\n  height: 10px;\n  display: block;\n  vertical-align: unset;\n\n  ", "\n\n  ", "\n"])), function (_a) {
    var type = _a.type;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    &[value]::-webkit-progress-value {\n      background: ", ";\n    }\n\n    &[value]::-moz-progress-bar {\n      background: ", ";\n    }\n  "], ["\n    &[value]::-webkit-progress-value {\n      background: ", ";\n    }\n\n    &[value]::-moz-progress-bar {\n      background: ", ";\n    }\n  "])), ProgressTypeMapper[type].background, ProgressTypeMapper[type].background);
}, function (_a) {
    var theme = _a.theme, nowColor = _a.nowColor;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    &[value]::-webkit-progress-bar {\n      background: ", ";\n      border-radius: 5px;\n    }\n\n    @-moz-document url-prefix() {\n      border-radius: 5px;\n      background: ", ";\n    }\n\n    &[value]::-webkit-progress-value {\n      ", ";\n      border-radius: 5px;\n      transition: width 0.15s ease;\n    }\n\n    &[value]::-moz-progress-bar {\n      ", ";\n      border-radius: 5px;\n      transition: width 0.15s ease;\n    }\n  "], ["\n    &[value]::-webkit-progress-bar {\n      background: ", ";\n      border-radius: 5px;\n    }\n\n    @-moz-document url-prefix() {\n      border-radius: 5px;\n      background: ", ";\n    }\n\n    &[value]::-webkit-progress-value {\n      ", ";\n      border-radius: 5px;\n      transition: width 0.15s ease;\n    }\n\n    &[value]::-moz-progress-bar {\n      ", ";\n      border-radius: 5px;\n      transition: width 0.15s ease;\n    }\n  "])), theme.colors.PRIMARY.ACCENT_2, theme.colors.PRIMARY.ACCENT_2, nowColor && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        background: ", ";\n      "], ["\n        background: ", ";\n      "])), nowColor), nowColor && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        background: ", ";\n      "], ["\n        background: ", ";\n      "])), nowColor));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=index.jsx.map